import { useCallback, useEffect } from 'react';
import { Provider, connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCurrentUser } from '../../services/CurrentUser';
import { subscribeKeyPress } from '../../services/GlobalEventHelper';
import { TEAM, createQuery, searchWithActions } from '../../services/HeaderSearchBar';
import store from '../../store';
import { actionCreators } from './ducks';
import HeaderSearchBar from './presenter';

function mapStateToProps(state) {
    return {
        showResults: state.headerSearchBar.showResults,
    };
}

function mapDispatchToProps(dispatch) {
    const actions = bindActionCreators(actionCreators, dispatch);
    return {
        actions: {
            ...actions,
            search: query => searchWithActions(query, actions.doSearch, actions.doSearchSuccess, actions.doSearchError),
        },
    };
}

function HeaderSearchBarWrapper(props) {
    const { actions } = props;

    const openSearch = useCallback(() => {
        actions.doUpdateQuery('');
        actions.search(createQuery(TEAM, getCurrentUser()));
        actions.doShowResults();
    }, [actions]);

    useEffect(() => {
        const unsubscribe = subscribeKeyPress(ev => {
            const J = 106;
            if (ev.keyCode === J || ev.charCode === J) {
                openSearch();
                ev.preventDefault();
            }
        });
        return unsubscribe;
    }, [openSearch]);

    return <HeaderSearchBar {...props} openSearch={openSearch} />;
}

const Connected = connect(mapStateToProps, mapDispatchToProps)(HeaderSearchBarWrapper);

export default function OuterComponent(props) {
    return (
        <Provider store={store}>
            <Connected {...props} />
        </Provider>
    );
}
